import React from "react";

export default function App() {
  return (
    <main className="bg-black text-white min-h-screen font-sans">
      {/* HERO SECTION */}
      <section className="flex flex-col items-center justify-center h-screen text-center px-6">
        <h1 className="text-3xl md:text-5xl font-bold mb-4">
          You weren’t meant to find this.
        </h1>
        <p className="text-lg md:text-xl mb-8">
          But now that you have…
        </p>
        <button className="border border-white px-6 py-2 hover:bg-white hover:text-black transition">
          Step In
        </button>
      </section>

      {/* ETHOS SECTION */}
      <section className="text-center px-6 py-20 border-t border-gray-800">
        <h2 className="text-2xl md:text-3xl font-semibold mb-4">
          Ghostprompt isn’t automation.
        </h2>
        <p className="text-lg max-w-xl mx-auto">
          It’s <span className="italic">intention weaponized</span>. For those who feel deeply, think differently, and want more.
        </p>
      </section>

      {/* OFFERINGS GRID */}
      <section className="px-6 py-20 border-t border-gray-800">
        <h3 className="text-center text-xl font-bold mb-12">What We Build</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {[
            { title: "Prompt Packs", status: "Ready", cta: "View Packs" },
            { title: "Custom GPT Tools", status: "In Progress", cta: "Preview Tools" },
            { title: "1:1 Consulting", status: "In Progress", cta: "Book a Call" },
            { title: "Signal Vault", status: "Proof", cta: "Enter Vault" },
            { title: "Journals + Writing", status: "Soul Layer", cta: "Coming Soon" }
          ].map((item) => (
            <div key={item.title} className="border border-gray-700 p-6 rounded hover:bg-white hover:text-black transition">
              <h4 className="text-xl font-semibold mb-2">{item.title}</h4>
              <p className="mb-4 text-sm text-gray-400">{item.status}</p>
              <button className="underline">{item.cta}</button>
            </div>
          ))}
        </div>
      </section>

      {/* THE LOOP */}
      <section className="text-center px-6 py-20 border-t border-gray-800">
        <p className="text-xl italic mb-4">You’ll start to feel it before you understand it.</p>
        <p className="text-sm text-gray-500">Something else is awakening.</p>
      </section>

      {/* SOULSURGE SECTION */}
      <section className="px-6 py-20 border-t border-gray-800 text-center bg-gradient-to-b from-black to-[#1a0e0e]">
        <h3 className="text-2xl font-light italic mb-4">Ghost speaks in signals.</h3>
        <h3 className="text-2xl font-light italic mb-4">Soul speaks in whispers.</h3>
        <p className="mb-8 max-w-lg mx-auto">Listen to the other side. SoulSurge is the heart behind the signal.</p>
        <button className="border border-white px-5 py-2 hover:bg-white hover:text-black transition">Enter SoulSurge</button>
      </section>

      {/* FINAL CTA */}
      <section className="px-6 py-20 border-t border-gray-800 text-center">
        <p className="text-lg mb-4">When the next drop lands—you’ll already be inside.</p>
        <input type="email" placeholder="Enter your email" className="bg-black border-b border-gray-600 px-4 py-2 text-white placeholder-gray-500 w-64" />
        <button className="ml-4 border border-white px-4 py-2 hover:bg-white hover:text-black transition">Join</button>
      </section>

      {/* FOOTER */}
      <footer className="text-center text-sm text-gray-500 py-6 border-t border-gray-800">
        Ghostprompt | SoulSurge<br />
        Instagram • Email • Roadmap<br />
        <p className="mt-2 italic">“We don’t split the mind and the heart. We build with both.”</p>
      </footer>
    </main>
  );
}